module.exports = __webpack_public_path__ + "img/2.9418d219.png";